module.exports = __webpack_public_path__ + "static/star-anise-c42152913e65e5f64c1365663b8972e5.svg";